export default "__VITE_ASSET__71de91e5__"